// CDN Worker starter templates.
// Mirrors edge-rs/examples/worker-demos — Cloudflare-Workers-style JS the edge
// runs as source (export default { fetch(request, env, ctx) }). Users pick one
// to seed the editor. `phase` hints which binding phase the template targets.

export const WORKER_TEMPLATES = [
  {
    key: 'blank',
    label: '空白 (Blank)',
    phase: 'request',
    description: '从零开始',
    code: `export default {
  async fetch(request, env, ctx) {
    // 在这里编写你的边缘逻辑
    return new Response("Hello from a YeapCDN edge worker!", {
      status: 200,
      headers: { "content-type": "text/plain; charset=utf-8" },
    });
  },
};
`,
  },
  {
    key: 'custom-response',
    label: '自定义响应 (Custom Response)',
    phase: 'request',
    description: '短路返回，不回源',
    code: `// 场景:自定义响应(短路,不回源)。
export default {
  fetch(request, env, ctx) {
    return new Response("Hello from a YeapCDN edge worker!", {
      status: 200,
      headers: { "content-type": "text/plain; charset=utf-8", "x-powered-by": "yeap-worker" },
    });
  },
};
`,
  },
  {
    key: 'redirect',
    label: '重定向 (Redirect)',
    phase: 'request',
    description: '旧路径 → 新路径 / http → https',
    code: `// 场景:重定向。命中则短路,否则 continue 交回源。
export default {
  fetch(request, env, ctx) {
    if (request.url.indexOf("/old/") >= 0) {
      const to = request.url.replace("/old/", "/new/");
      return Response.redirect(to, 301);
    }
    return { action: "continue" };
  },
};
`,
  },
  {
    key: 'request-header-rewrite',
    label: '请求头改写 (Request Header)',
    phase: 'request',
    description: '为回源请求增删改请求头',
    code: `// 场景:请求头改写(注入/删除后交回源)。
// headers:设置/覆盖回源请求头;remove_headers:删除回源请求头。
// 逐跳头(connection/host 等)和 X-CDN-* 受保护,不会被修改。
export default {
  fetch(request, env, ctx) {
    return {
      action: "continue",
      headers: { "x-edge-worker": "yeap", "x-original-url": request.url },
      remove_headers: ["x-debug"],
    };
  },
};
`,
  },
  {
    key: 'response-header-rewrite',
    label: '响应头改写 (Response Header)',
    phase: 'request',
    description: '给响应加安全头 / CORS',
    code: `// 场景:响应头改写(安全头 / CORS)。按默认的请求阶段绑定即可。
// response_headers 会加到最终响应上;源站的状态码和内容不变。
export default {
  fetch(request, env, ctx) {
    return {
      action: "continue",
      response_headers: {
        "strict-transport-security": "max-age=31536000; includeSubDomains",
        "x-content-type-options": "nosniff",
        "x-frame-options": "SAMEORIGIN",
        "access-control-allow-origin": "*",
      },
    };
  },
};
`,
  },
  {
    key: 'auth-token',
    label: '鉴权 (Auth Token)',
    phase: 'request',
    description: '校验请求头/查询串里的 token',
    code: `// 场景:简单鉴权。缺失/错误 token 直接 401,否则放行。
export default {
  fetch(request, env, ctx) {
    const auth = request.headers.get("authorization") || "";
    const expected = "Bearer " + (env.API_TOKEN || "secret-token");
    if (auth !== expected) {
      return new Response("Unauthorized", { status: 401 });
    }
    return { action: "continue" };
  },
};
`,
  },
  {
    key: 'crypto-toolbox',
    label: 'Crypto 工具箱 (Crypto)',
    phase: 'request',
    description: 'SubtleCrypto / HMAC / 随机 / UUID',
    code: `// 场景:Crypto API 工具箱(摘要 / HMAC / 随机 / UUID)。
export default {
  async fetch(request, env, ctx) {
    const data = "The quick brown fox";
    const digest = await crypto.subtle.digest("SHA-256", data);
    return Response.json({
      sha256: arrayBufferToHex(digest),
      md5: crypto.md5(data),
      hmac: crypto.hmac("sha256", "key", data),
      uuid: crypto.randomUUID(),
      base64: btoa("hello"),
    });
  },
};
`,
  },
  {
    key: 'fetch-passthrough',
    label: 'Fetch 透传 (Proxy)',
    phase: 'request',
    description: 'return fetch(url) 代理到上游',
    code: `// 场景:fetch 透传/代理。return fetch(url) 把请求代理到另一 URL。
// 注意:目标受 SSRF 白名单约束,内网/环回会被拒。
export default {
  fetch(request, env, ctx) {
    const upstream = env.UPSTREAM || "https://example.com/";
    return fetch(upstream, {
      method: request.method,
      headers: { "x-forwarded-by": "yeap-worker" },
    });
  },
};
`,
  },
  {
    key: 'ab-test-cookie',
    label: 'A/B 测试 (Cookie)',
    phase: 'request',
    description: '按 cookie 分流并回写分组',
    code: `// 场景:A/B 分流。读 cookie 决定分组,无则随机分配并 set-cookie。
// 源站读请求头 x-ab-bucket 返回对应版本。
export default {
  fetch(request, env, ctx) {
    const cookie = request.headers.get("cookie") || "";
    const m = /(?:^|;\\s*)ab_bucket=(A|B)(?:;|$)/.exec(cookie);
    const bucket = m ? m[1] : (Math.random() < 0.5 ? "A" : "B");
    const out = { action: "continue", headers: { "x-ab-bucket": bucket } };
    if (!m) {
      // 首次访问:回写 cookie,之后固定在同一组。
      out.response_headers = { "set-cookie": "ab_bucket=" + bucket + "; Path=/; Max-Age=86400; SameSite=Lax" };
    }
    return out;
  },
};
`,
  },
];

export default WORKER_TEMPLATES;
